import React from 'react';
import { Box, Button } from '@mui/material';

import { closeSettingsPanel } from '../../../../../store/actions/appActions';
import { useAppDispatch } from '../../../../hooks';

// An alternative to `SettingsSaveButton` for cases when settings can not be saved, as the user still must be able to
//   close the panel.
export function SettingsCloseButton() {
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ p: 1, display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        sx={{ py: 1, m: 1, mr: 0 }}
        variant="outlined"
        onClick={() => {
          // no need for a confirmation dialog as there is no risk of losing unsaved changes
          dispatch(closeSettingsPanel());
        }}
      >
        Close
      </Button>
    </Box>
  );
}
